import { ReactNode } from 'react';
import { AppShell } from '@/components/layout/AppShell';

// Sprint 38 — MainLayout is now a thin wrapper around AppShell.
// Preserved as a default export so the ~50 pages currently importing
// `from '@/layouts/MainLayout'` continue to compile without per-page
// edits. Phase 4 page restyles can migrate to AppShell directly when
// touching each file.

interface MainLayoutProps {
  children?: ReactNode;
}

export default function MainLayout({ children }: MainLayoutProps) {
  return <AppShell>{children}</AppShell>;
}
